export enum Entity {
  CANDIDATE = 'candidate',
  CONTACT = 'contact',
  COMPANY = 'company',
}
